import classNames from 'classnames'
import { useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { withTranslation } from 'react-i18next'
import LanguageChanger from '../components/languageChanger/LanguageChanger'
import Confirmation from '../components/sections/confirmation/Confirmation'
import Logo from '../components/sections/logo/logo'
import PolicyBooking from '../components/sections/policyBooking/PolicyBooking'
import config from '../config'
import ChildPlanFormDataContext from '../contexts/ChildPlanFormDataContext'
import ParentFormDataContext from '../contexts/ParentFormDataContext'
import PaymentFormDataContext from '../contexts/PaymentFormDataContext'
import ReturnCustomerFormDataContext from '../contexts/ReturnCustomerFormDataContext'
import { ChildDataObject } from '../contexts/contextDataObjects/ChildDataObject'
import { ParentDataObject } from '../contexts/contextDataObjects/ParentDataObject'
import { PaymentFormDataObject } from '../contexts/contextDataObjects/PaymentFormDataObject'
import { ReturnCustomerDataObject } from '../contexts/contextDataObjects/ReturnCustomerDataObject'
import i18n from '../i18n'
import { setRouteParam } from '../utils/routeHelper'

ReactGA.initialize(config.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || '')

function Main() {
    //default params "?prov=ON&lang=0"
    const urlParameters = new URLSearchParams(window.location.search)
    const location = urlParameters.get('prov')?.toUpperCase()
    const language = Number(urlParameters.get('lang'))
    const orgGuidFromUrl = urlParameters.get('og')?.toString()

    if (orgGuidFromUrl) {
        ParentDataObject.OrgGuid = orgGuidFromUrl
    } else {
        ParentDataObject.OrgGuid = ""
    }

    const [returnCustomerFormData, setReturnCustomerFormData] = useState(ReturnCustomerDataObject)
    const [parentFormData, setParentFormData] = useState(ParentDataObject)
    const [childPlanFormData, setChildPlanFormData] = useState([ChildDataObject])
    const [paymentFormData, setPaymentFormData] = useState(PaymentFormDataObject)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)

    const provinceInput = parentFormData.ParentFormDataInput.find(x => x.Name === "Province")

    useEffect(() => {
        i18n.changeLanguage(language === 0 ? 'enUS' : 'frCA')

        if (!location) {
            setIsModalOpen(true)
        } else {
            setIsModalOpen(false)
            setLocationAndLanguage()
        }
    }, [language, provinceInput?.ListItems])

    const handleLanguageChange = () => {
        const langChange = Number(parentFormData.Language) === 0 ? 1 : 0
        const lang = langChange === 0 ? 'enUS' : 'frCA'
        i18n.changeLanguage(lang)
        setParentFormData({
            ...parentFormData,
            Language: langChange
        })
        setRouteParam(parentFormData.Province.id, langChange)
    }

    const setLocationAndLanguage = () => {
        if (provinceInput && provinceInput.ListItems) {
            let provName = provinceInput.ListItems.find(
                (x) => x.id === location
            )?.name
            const updatedProvinceInput = {
                ...provinceInput,
                IsBlur: true,
                IsFocus: false,
                IsValid: true,
            }
            const updatedFormInputs = [...parentFormData.ParentFormDataInput]
            const index = updatedFormInputs.indexOf(provinceInput)
            updatedFormInputs[index] = updatedProvinceInput
            setParentFormData({
                ...parentFormData,
                Language: language,
                Province: {
                    id: location,
                    name: provName ? provName : 'Ontario',
                },
                ParentFormDataInput: updatedFormInputs,
            })
        }
    }
    return (
        <ReturnCustomerFormDataContext.Provider
            value={{ returnCustomerFormData, setReturnCustomerFormData }}
        >
            <ParentFormDataContext.Provider
                value={{
                    parentFormData,
                    setParentFormData,
                }}
            >
                <ChildPlanFormDataContext.Provider
                    value={{ childPlanFormData, setChildPlanFormData }}
                >
                    <PaymentFormDataContext.Provider
                        value={{ paymentFormData, setPaymentFormData }}
                    >
                        <div className="bg-[#f5f5f5] h-full space-y-10 z-50">
                            <div className='bg-white w-full top-0 z-50 fixed h-[6.8rem] shadow-md flex justify-center items-center '>
                                <div className={classNames('flex flex-row justify-between lg:w-[55rem] md:w-[31rem] w-[20rem]')}>
                                    <div className='my-1 float-left'>
                                        <Logo width={225} height={100} />
                                    </div>
                                    <div className="float-right pt-4">
                                        <LanguageChanger
                                            handleClick={handleLanguageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <>
                                {!showConfirmation ? (
                                    <div className='pt-[6rem] lg:pb-[2rem] pb-[7rem]'>
                                        <PolicyBooking
                                            setShowConfirmation={setShowConfirmation}
                                            isModalOpen={isModalOpen}
                                            setIsModalOpen={setIsModalOpen}
                                        />
                                    </div>
                                ) : (
                                    <div className='pt-[3.5rem] pb-[8rem]'>
                                        <Confirmation
                                            setShowConfirmation={setShowConfirmation}
                                        />
                                    </div>
                                )}
                            </>
                        </div>
                    </PaymentFormDataContext.Provider>
                </ChildPlanFormDataContext.Provider>
            </ParentFormDataContext.Provider>
        </ReturnCustomerFormDataContext.Provider>
    )
}

export default withTranslation()(Main)
